"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultConfiguration = void 0;
exports.DefaultConfiguration = {
    fragmentPlaceholderConfig: {
        lazyLoadUrlAttribute: 'data-lazy-url',
        toSetWhenFollow: 'data-intersect',
        FragmentIdAttribute: 'data-lazy-id'
    },
    eventBus: {
        name: 'lazy-loading-bus',
        emittedEvent: 'fragmentLoaded'
    },
    logger: {
        level: 'warn'
    }
};
//# sourceMappingURL=default.configuration.js.map